// components/DeviceSecurityCheck.js
import i18next from "i18next";
import React, {useEffect, useState} from "react";
import {Alert, Button, Modal} from "antd";
import {SafetyOutlined} from "@ant-design/icons";
import {isTrustedCurrentDevice} from "../../backend/UserDeviceBackend";
import * as Setting from "../../Setting";
import * as DeviceBackend from "../../backend/UserDeviceBackend";

const DeviceSecurityCheck = ({visible, onClose}) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (visible) {
      checkAndShowModal();
    }
  }, [visible]);
  const checkAndShowModal = async() => {
    try {
      const res = await isTrustedCurrentDevice();
      if (res.status === "ok" && res.data === false) {
        setShowModal(true);
      }
    } catch (error) {
      setShowModal(false);
    }
  };

  const handleTrustDevice = async() => {
    setLoading(true);
    try {
      const result = await DeviceBackend.markCurrentDeviceTrusted();
      if (result.status === "ok") {
        Setting.showMessage("success", i18next.t("general:The device was registered as a safe device."));
        setShowModal(false);
        if (onClose) {onClose();}
      } else {
        Setting.showMessage("error", i18next.t("general:Error in registering the device"));
      }
    } catch (error) {
      Setting.showMessage("error", i18next.t("general:connection error"));
    } finally {
      setLoading(false);
    }
  };

  const handleNotTrust = () => {
    Setting.showMessage("info", i18next.t("general:The device was registered as a secure device."));
    setShowModal(false);
    if (onClose) {onClose();}
  };

  if (!showModal) {
    return null;
  }

  return (
    <Modal
      title={
        <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
          <SafetyOutlined style={{color: "#faad14"}} />
          <span>{i18next.t("general:check device security")}</span>
        </div>
      }
      visible={showModal}
      onCancel={handleNotTrust}
      footer={[
        <Button
          key="no"
          onClick={handleNotTrust}
          disabled={loading}
        >
          {i18next.t("general:No")}
        </Button>,
        <Button
          key="yes"
          type="primary"
          onClick={handleTrustDevice}
          loading={loading}
        >
          {i18next.t("general:Yes")}
        </Button>,
      ]}
      width={400}
      centered
      closable={false}
      maskClosable={false}
    >
      <div style={{textAlign: "center", padding: "20px 0"}}>
        <Alert
          message= {i18next.t("general:Do you consider this device safe?")}
          description={i18next.t("general:If this is your personal device, mark it as a secure device so you don't need two-step verification on future sign-ins.")}
          type="warning"
          showIcon
        />
        <div style={{marginTop: 20, fontSize: "12px", color: "#666"}}>
          {i18next.t("general:Do not mark public devices as secure devices.")}
        </div>
      </div>
    </Modal>
  );
};

export default DeviceSecurityCheck;
